export default __webpack_public_path__ + "static/media/01-empathize.c4d6c45a.png";